import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { TaxValidator, TaxValidatorResponse } from '@interfaces'
import { Observable } from 'rxjs'

@Injectable({
	providedIn: 'root'
})
export class BillingService {
	private http = inject(HttpClient)
	url = '/tax-validator/validate'

	taxValidator(fiscalCode: TaxValidator): Observable<TaxValidatorResponse> {
		return this.http.post<TaxValidatorResponse>(`${this.url}`, fiscalCode)
	}
}
